import { render, staticRenderFns } from "./lyric.vue?vue&type=template&id=081fad22&scoped=true&"
import script from "./lyric.vue?vue&type=script&lang=js&"
export * from "./lyric.vue?vue&type=script&lang=js&"
import style0 from "./lyric.vue?vue&type=style&index=0&id=081fad22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fad22",
  null
  
)

export default component.exports